import { defineMessages } from 'react-intl';

export default defineMessages({
  sectionTitle: {
    id: 'fastCover.step14.sectionTitle',
    defaultMessage: 'Ready to submit',
  },
  youAreAboutToSubmitYourClaimAnd: {
    id: 'fastCover.step14.youAreAboutToSubmitYourClaimAnd',
    defaultMessage: 'You are about to submit your claim and:',
  },
  note1: {
    id: 'fastCover.step14.note1',
    defaultMessage: 'declare that all information provided and documents submitted are true and correct.',
  },
  note2: {
    id: 'fastCover.step14.note2',
    defaultMessage: 'understand and acknowledge that providing false or misleading information on an insurance claim is a criminal offence under Australian Law and can lead to prosecution.',
  },
  note3: {
    id: 'fastCover.step14.note3',
    defaultMessage: 'authorise any person or organisation to provide Hollard or its representative with any information that they may request in relation to this Claim.',
  },
  note4: {
    id: 'fastCover.step14.note4',
    defaultMessage: 'understand that if the information provided is inaccurate or incorrect my claim may be refused.',
  },
  note5: {
    id: 'fastCover.step14.note5',
    defaultMessage: 'acknowledge that my personal information may be disclosed to, and obtained from, certain other parties including the Insurance Reference Database, other insurers and government agencies.',
  },
  clickSubmitClaim: {
    id: 'fastCover.step14.clickSubmitClaim',
    defaultMessage: 'Click the "Submit Claim" button below to submit your claim.',
  },
  agree: {
    id: 'fastCover.step14.agree',
    defaultMessage: 'I agree to these terms and conditions.',
  },
  privacyStatement: {
    id: 'fastCover.step14.privacyStatement',
    defaultMessage: 'Privacy Statement',
  },
  privacyStatementMessage: {
    id: 'fastCover.step14.privacyStatementMessage',
    defaultMessage: 'Your personal information is handled in accordance with our Privacy Policy, available at #Link#. The personal information requested on this form is collected for assessing claims and assisting us with administrative operations. Your information may also assist us in developing our products or services. Where required by law, your personal information may be disclosed to third parties, including related companies, advisers, people involved in claims, our agents and service providers. If you do not provide us with the information, we may not be able to process your claim.',
  },
  errorNotice: {
    id: 'fastCover.step14.errorNotice',
    defaultMessage: 'Please ensure that all sections are completed to submit the claim.',
  },
  section1: {
    id: 'fastCover.step13.section1',
    defaultMessage: 'Section 1 - Your Details',
  },
  section2: {
    id: 'fastCover.step13.section2',
    defaultMessage: 'Section 2 - Bank Details',
  },
  section4: {
    id: 'fastCover.step13.section4',
    defaultMessage: 'Section 3 - What Happened',
  },
  section5: {
    id: 'fastCover.step13.section5',
    defaultMessage: 'Section 4 - Cancellation, Additional Expenses & Travel Delay',
  },
  section6: {
    id: 'fastCover.step13.section6',
    defaultMessage: 'Section 5 - Damaged, Lost or Stolen Luggage, Travel Documents or Cash',
  },
  section7: {
    id: 'fastCover.step13.section7',
    defaultMessage: 'Section 6 - Overseas Emergency Medical or Overseas Emergency Dental Expenses',
  },
  section8: {
    id: 'fastCover.step13.section8',
    defaultMessage: 'Section 7 - Rental Vehicle Excess',
  },
  section9: {
    id: 'fastCover.step13.section9',
    defaultMessage: 'Section 8 - Snow Sports Optional Cover',
  },
  section10: {
    id: 'fastCover.step13.section10',
    defaultMessage: 'Section 9 - Other Claims',
  },
  section11: {
    id: 'fastCover.step13.section11',
    defaultMessage: 'Section 10 - Supporting Documentation',
  },
  claimSummary: {
    id: 'fastCover.step13.claimSummary',
    defaultMessage: 'Fast Cover Claim Summary - \'{defaultMessage}\'',
  },
  notice: {
    id: 'fastCover.step13.notice',
    defaultMessage: 'The file will start to download',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step14/messages.js